import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'neo-filtros-navegacion-dia',
  templateUrl: './filtros-navegacion-dia.component.html',
  styleUrls: ['./filtros-navegacion-dia.component.scss']
})
export class FiltrosNavegacionDiaComponent implements OnInit {


  @Input() diaVista: Date = new Date();
  @Output() cambioDiaVista = new EventEmitter<any>();
  constructor() { }

  ngOnInit(): void {
  }

  onVistaCambia(evento) { }

  onDiaVistaCambia(evento) {
    this.cambioDiaVista.emit(evento);
  }

}
